function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function courseSelect() {
  return import(
    /* webpackChunkName: "page-courseSelect" */ '@/pages/courseSelect.vue'
  )
}
function courseSelection() {
  return import(
    /* webpackChunkName: "page-courseSelection" */ '@/pages/courseSelection.vue'
  )
}
function enrolmentEnglish() {
  return import(
    /* webpackChunkName: "page-enrolmentEnglish" */ '@/pages/enrolmentEnglish.vue'
  )
}
function enrolmentEnglishComplete() {
  return import(
    /* webpackChunkName: "page-enrolmentEnglishComplete" */ '@/pages/enrolmentEnglishComplete.vue'
  )
}
function enrolmentEnglishSelectProcess() {
  return import(
    /* webpackChunkName: "page-enrolmentEnglishSelectProcess" */ '@/pages/enrolmentEnglishSelectProcess.vue'
  )
}
function enrolmentEnglishUserForm() {
  return import(
    /* webpackChunkName: "page-enrolmentEnglishUserForm" */ '@/pages/enrolmentEnglishUserForm.vue'
  )
}
function enrolmentGlobal() {
  return import(
    /* webpackChunkName: "page-enrolmentGlobal" */ '@/pages/enrolmentGlobal.vue'
  )
}
function enrolmentGlobalComplete() {
  return import(
    /* webpackChunkName: "page-enrolmentGlobalComplete" */ '@/pages/enrolmentGlobalComplete.vue'
  )
}
function enrolmentGlobalSearch() {
  return import(
    /* webpackChunkName: "page-enrolmentGlobalSearch" */ '@/pages/enrolmentGlobalSearch.vue'
  )
}
function enrolmentGlobalUserForm() {
  return import(
    /* webpackChunkName: "page-enrolmentGlobalUserForm" */ '@/pages/enrolmentGlobalUserForm.vue'
  )
}
function main() {
  return import(/* webpackChunkName: "page-main" */ '@/pages/main.vue')
}
function myPage() {
  return import(/* webpackChunkName: "page-myPage" */ '@/pages/myPage.vue')
}
function preview() {
  return import(/* webpackChunkName: "page-preview" */ '@/pages/preview.vue')
}
function teacherList() {
  return import(
    /* webpackChunkName: "page-teacherList" */ '@/pages/teacherList.vue'
  )
}
function teacherListG() {
  return import(
    /* webpackChunkName: "page-teacherListG" */ '@/pages/teacherListG.vue'
  )
}
function usr001_1_1() {
  return import(
    /* webpackChunkName: "page-usr001-1-1" */ '@/pages/usr001-1-1.vue'
  )
}
function usr006_2() {
  return import(/* webpackChunkName: "page-usr006-2" */ '@/pages/usr006-2.vue')
}
function usr009() {
  return import(/* webpackChunkName: "page-usr009" */ '@/pages/usr009.vue')
}
function usr010_3() {
  return import(/* webpackChunkName: "page-usr010-3" */ '@/pages/usr010-3.vue')
}
function callEnglish_complete() {
  return import(
    /* webpackChunkName: "page-callEnglish-complete" */ '@/pages/callEnglish/complete.vue'
  )
}
function callEnglish_payment() {
  return import(
    /* webpackChunkName: "page-callEnglish-payment" */ '@/pages/callEnglish/payment.vue'
  )
}
function callEnglish_processSelect() {
  return import(
    /* webpackChunkName: "page-callEnglish-processSelect" */ '@/pages/callEnglish/processSelect.vue'
  )
}
function common_faq() {
  return import(
    /* webpackChunkName: "page-common-faq" */ '@/pages/common/faq.vue'
  )
}
function common_introuduceClass() {
  return import(
    /* webpackChunkName: "page-common-introuduceClass" */ '@/pages/common/introuduceClass.vue'
  )
}
function common_userform() {
  return import(
    /* webpackChunkName: "page-common-userform" */ '@/pages/common/userform.vue'
  )
}
function global_complete() {
  return import(
    /* webpackChunkName: "page-global-complete" */ '@/pages/global/complete.vue'
  )
}
function global_payment() {
  return import(
    /* webpackChunkName: "page-global-payment" */ '@/pages/global/payment.vue'
  )
}
function global_programselect() {
  return import(
    /* webpackChunkName: "page-global-programselect" */ '@/pages/global/programselect.vue'
  )
}
function global_selectprogram() {
  return import(
    /* webpackChunkName: "page-global-selectprogram" */ '@/pages/global/selectprogram.vue'
  )
}
function notice_detail__detailNotice() {
  return import(
    /* webpackChunkName: "page-notice-detail-detailNotice" */ '@/pages/notice/detail/_detailNotice.vue'
  )
}
function notice__code() {
  return import(
    /* webpackChunkName: "page-notice-code" */ '@/pages/notice/_code.vue'
  )
}
function settings__code() {
  return import(
    /* webpackChunkName: "page-settings-code" */ '@/pages/settings/_code.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: index,
  },
  {
    name: 'courseSelect',
    path: 'courseSelect',
    component: courseSelect,
  },
  {
    name: 'courseSelection',
    path: 'courseSelection',
    component: courseSelection,
  },
  {
    name: 'enrolmentEnglish',
    path: 'enrolmentEnglish',
    component: enrolmentEnglish,
  },
  {
    name: 'enrolmentEnglishComplete',
    path: 'enrolmentEnglishComplete',
    component: enrolmentEnglishComplete,
  },
  {
    name: 'enrolmentEnglishSelectProcess',
    path: 'enrolmentEnglishSelectProcess',
    component: enrolmentEnglishSelectProcess,
  },
  {
    name: 'enrolmentEnglishUserForm',
    path: 'enrolmentEnglishUserForm',
    component: enrolmentEnglishUserForm,
  },
  {
    name: 'enrolmentGlobal',
    path: 'enrolmentGlobal',
    component: enrolmentGlobal,
  },
  {
    name: 'enrolmentGlobalComplete',
    path: 'enrolmentGlobalComplete',
    component: enrolmentGlobalComplete,
  },
  {
    name: 'enrolmentGlobalSearch',
    path: 'enrolmentGlobalSearch',
    component: enrolmentGlobalSearch,
  },
  {
    name: 'enrolmentGlobalUserForm',
    path: 'enrolmentGlobalUserForm',
    component: enrolmentGlobalUserForm,
  },
  {
    name: 'main',
    path: 'main',
    component: main,
  },
  {
    name: 'myPage',
    path: 'myPage',
    component: myPage,
  },
  {
    name: 'preview',
    path: 'preview',
    component: preview,
  },
  {
    name: 'teacherList',
    path: 'teacherList',
    component: teacherList,
  },
  {
    name: 'teacherListG',
    path: 'teacherListG',
    component: teacherListG,
  },
  {
    name: 'usr001-1-1',
    path: 'usr001-1-1',
    component: usr001_1_1,
  },
  {
    name: 'usr006-2',
    path: 'usr006-2',
    component: usr006_2,
  },
  {
    name: 'usr009',
    path: 'usr009',
    component: usr009,
  },
  {
    name: 'usr010-3',
    path: 'usr010-3',
    component: usr010_3,
  },
  {
    name: 'callEnglish-complete',
    path: 'callEnglish/complete',
    component: callEnglish_complete,
  },
  {
    name: 'callEnglish-payment',
    path: 'callEnglish/payment',
    component: callEnglish_payment,
  },
  {
    name: 'callEnglish-processSelect',
    path: 'callEnglish/processSelect',
    component: callEnglish_processSelect,
  },
  {
    name: 'common-faq',
    path: 'common/faq',
    component: common_faq,
  },
  {
    name: 'common-introuduceClass',
    path: 'common/introuduceClass',
    component: common_introuduceClass,
  },
  {
    name: 'common-userform',
    path: 'common/userform',
    component: common_userform,
  },
  {
    name: 'global-complete',
    path: 'global/complete',
    component: global_complete,
  },
  {
    name: 'global-payment',
    path: 'global/payment',
    component: global_payment,
  },
  {
    name: 'global-programselect',
    path: 'global/programselect',
    component: global_programselect,
  },
  {
    name: 'global-selectprogram',
    path: 'global/selectprogram',
    component: global_selectprogram,
  },
  {
    name: 'notice-detail-detailNotice',
    path: 'notice/detail/:detailNotice?',
    component: notice_detail__detailNotice,
  },
  {
    name: 'notice-code',
    path: 'notice/:code?',
    component: notice__code,
  },
  {
    name: 'settings-code',
    path: 'settings/:code?',
    component: settings__code,
  },
]
